import { render, staticRenderFns } from "./TaxonomyTags.vue?vue&type=template&id=0d62a1a8&"
import script from "./TaxonomyTags.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports